/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDirectoryReviewItemsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListDirectoryReviewItemsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListDirectoryReviewItemsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDirectoryReviewItemsSecurity$outboundSchema: z.ZodMiniType<
  ListDirectoryReviewItemsSecurity$Outbound,
  ListDirectoryReviewItemsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDirectoryReviewItemsSecurityToJSON(
  listDirectoryReviewItemsSecurity: ListDirectoryReviewItemsSecurity,
): string {
  return JSON.stringify(
    ListDirectoryReviewItemsSecurity$outboundSchema.parse(
      listDirectoryReviewItemsSecurity,
    ),
  );
}

/** @internal */
export type ListDirectoryReviewItemsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDirectoryReviewItemsRequest$outboundSchema: z.ZodMiniType<
  ListDirectoryReviewItemsRequest$Outbound,
  ListDirectoryReviewItemsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listDirectoryReviewItemsRequestToJSON(
  listDirectoryReviewItemsRequest: ListDirectoryReviewItemsRequest,
): string {
  return JSON.stringify(
    ListDirectoryReviewItemsRequest$outboundSchema.parse(
      listDirectoryReviewItemsRequest,
    ),
  );
}
